// extracted by mini-css-extract-plugin
export default {"inputContainer":"checkbox_inputContainer__FLiVZ","input":"checkbox_input__L4q0S","label":"checkbox_label__jMYFB"};